import { Component, ChangeDetectionStrategy, signal, computed } from '@angular/core';

@Component({
  selector: 'app-account-balance',
  templateUrl: './account-balance.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountBalanceComponent {
  chartData = signal([
    { label: 'Income', value: 4500 },
    { label: 'Expenses', value: 1850.75 },
  ]);

  maxVal = computed(() => Math.max(...this.chartData().map(d => d.value)));
}
